import React, { useMemo } from 'react';
import { getCompetitorChartData } from '../utils/dashboardData';
import styles from '../Dashboard.module.scss';

export default function CompetitorsTile({ studies = [], companies = [] }) {
  const chartData = useMemo(() => getCompetitorChartData(studies, companies), [studies, companies]);

  return (
    <div className={`${styles.tile} ${styles.competitorsTile}`}>
      <h3 className={styles.tileTitle}>Etudes compétiteurs</h3>
      {chartData.length === 0 ? (
        <p className={styles.emptyState}>Aucune étude compétiteur</p>
      ) : (
        <div className={styles.competitorsChart}>
          {chartData.map(area => (
            <div key={area.areaName} className={styles.competitorGroup}>
              <div className={styles.competitorBars}>
                {area.companies.map(company => (
                  <div key={`${area.areaName}-${company.companyName}`} className={styles.competitorBarWrap}>
                    <span className={styles.competitorBarLabel}>
                      {company.companyName} {company.studyCount}
                    </span>
                    <div
                      className={styles.competitorBar}
                      style={{
                        height: `${Math.max(18, (company.patientCount / area.maxPatients) * 110)}px`,
                        backgroundColor: company.color
                      }}
                    >
                      <span>{company.patientCount}</span>
                    </div>
                  </div>
                ))}
              </div>
              <p className={styles.competitorArea}>{area.areaName}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
